import React from 'react';

import {
  useUserStore,
  userStoreSelector,
} from '@repo/editor/src/stores/userStore';
import { Spacer } from '@repo/ui/components/Spacer';
import { H5 } from '@repo/ui/components/Typography';

import ContentWrapper from 'components/Landing/ContentWrapper/ContentWrapper';
import SubscriptionCard from 'components/SubscriptionCard/SubscriptionCard';

const YourSubscription = ({ slice }) => {
  const user = useUserStore(userStoreSelector.user);

  if (!user) {
    return null;
  }

  return (
    <ContentWrapper
      background={slice.primary.background}
      className="your-subscription"
      customWidth="1000px"
    >
      <H5>Your Subscription</H5>
      <Spacer height="8px" />
      <SubscriptionCard plan={user.plan} />
    </ContentWrapper>
  );
};

export default YourSubscription;
